import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Profile.module.sass";
import { useAuth } from "../../../contexts/AuthContext";
import { getCompanyContracts } from "../../../services/contract.service";

// Fonction pour formater la date
const formatDate = (dateString) => {
  if (!dateString) return "Non définie";
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const Profile = ({ company }) => {
  const { currentUser } = useAuth();
  const [activeContractsCount, setActiveContractsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  
  // Récupérer les contrats actifs de l'entreprise
  useEffect(() => {
    const fetchContracts = async () => {
      if (company.id) {
        try {
          setIsLoading(true);
          const contractsResult = await getCompanyContracts(company.id);
          // Filtrer les contrats actifs (non terminés)
          const activeContracts = contractsResult.items.filter(
            contract => contract.status !== 'terminated' && contract.status !== 'cancelled'
          );
          setActiveContractsCount(activeContracts.length);
        } catch (error) {
          console.error('Erreur lors de la récupération des contrats:', error);
          setActiveContractsCount(0);
        } finally {
          setIsLoading(false);
        }
      }
    };
    
    fetchContracts();
  }, [company?.id]);

  // Si aucune entreprise n'est fournie, afficher un message de chargement
  if (!company) {
    return <div className={styles.profile}>Chargement des données...</div>;
  }

  // Extraire la première lettre du nom de l'entreprise pour l'avatar
  const firstLetter = company.name ? company.name.charAt(0).toUpperCase() : "C";
  const secondLetter = company.corporate_name ? company.corporate_name.charAt(0).toUpperCase() : "";

  return (
    <div className={styles.profile}>
      <div className={styles.details}>
        <div className={styles.avatar}>
        <img src={company.logoUrl || '/images/content/company_logo.png'} alt="Avatar" />
        </div>
        <div className={styles.wrap}>
          <div className={cn("h4", styles.man)}>{company.name || company.corporate_name || "Entreprise"}</div>
          <div className={styles.login}>
            {company.sector || "Secteur non défini"}
          </div>
        </div>
      </div>
      
      <div className={styles.statusInfo}>
        <div className={styles.statusContainer}>
          <div className={styles.statusGroup}>
            <div className={styles.login}>Contrats actifs</div>
            <div className={cn(
              styles.statusBadge,
              'status-type',
              (activeContractsCount > 0) ? 'status-green-dark' : 'status-gray-dark'
            )}>
              {isLoading ? 'Chargement...' : `${activeContractsCount} contrat(s)`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
